<template>
</template>

<script>
import {checkboxInputMixin} from "../../helpers/checkboxInput";
export default {
    mixins: [checkboxInputMixin],
    props: {
        reportsData: Object,
        perPage: String,
    },
    data() {
        return {
            reports: {},
            forAllReports: false,
            selectedTypes: [],
            numbersPerPage: ["10", "25", "50", "100"],
            limit: 0,
        }
    },
    mounted() {
        this.reportsData.data.map(report => {
            this.$set(this.reports, report.id, {
                checked: false
            })
        });
        this.limit = this.perPage;
    },
    methods: {
        changeNumberPerPage(limit) {
          this.limit = limit;
          setTimeout(() => {
              this.$refs.form.submit();
          }, 100);
        },
        async setTypes(types) {
          this.selectedTypes = types;
          await this.requestSetTypes();
        },
        async requestSetTypes() {
            return axios.post(route('default-reports.set-types-bulk'), {
                forAllReports: this.forAllReports,
                selectedReports: this.getSelectedReports,
                selectedTypes: this.selectedTypes
            }).then(response => {
                if (response.status) {
                    this.$notifications.success('Changes will soon come into force');
                    setTimeout(() => location.reload(), 500);
                }
            })
        }
    },
    computed: {
        hasChecked() {
            for (let key in this.reports) {
                if (this.reports[key].checked) {
                    return true;
                }
            }
            return false;

        },
        getSelectedReports() {
            return Object.keys(this.reports).filter(key => {
                return this.reports[key].checked
            });
        }
    },
    watch: {
        forAllReports: function (val) {
            this.allItemsSelected = val;
            Object.keys(this.reports).forEach(key => {
                this.reports[key].checked = val
            });
        }
    }
}
</script>

<style scoped lang="scss">

</style>
